module.exports = __webpack_public_path__ + "static/media/icon-consolidador.ca155340.svg";